module.exports = __webpack_public_path__ + "static/media/portfolio3.3d59577c.png";